<form class="mc-spring-board">
  <mat-tab-group mat-stretch-tabs="false" [selectedIndex]="selectedTabIndex" class="mc-spring-board-body mc-arrow-tabs mc-arrow-tabs-border" color="secondary-invert">
    <mat-tab label="Teams">
      <div class="mc-spring-board">
        <div class="mc-spring-board-header">
          <button #popupTriggerTeams *ngIf="(canManageSites$ | async)" type="button" color="primary" [disabled]="savingState.loading$ | async" mat-raised-button [mcPopupTriggerAutoClose]="false" [mcPopupTriggerFor]="addSiteTeamsPopup" [mcPopupWidth]="506">
            <div class="mc-d-flex mc-align-items-center">
              <ng-container *ngIf="savingState.loading$ | async; else addSiteTeams">Adding Site Teams</ng-container>
              <ng-template #addSiteTeams>Add Site Teams</ng-template>
              &nbsp;
              <span class="mc-fill-remaining-flex-space"></span>
              <mc-dropdown-arrow></mc-dropdown-arrow>
            </div>
          </button>

          <mat-form-field mcColor="secondary" class="mc-form-field">
            <mat-label>Filter Site Teams</mat-label>
            <div class="mc-site-access-form-access-site-entity">
              <input #filterSiteTeams matInput placeholder="Name" name="filterSiteTeam" (keyup)="onFilterSiteTeamsKeyUp($event)">
            </div>
          </mat-form-field>
          <mc-filter-bar display="list" [filterable]="siteTeamsList"></mc-filter-bar>
        </div>
        <div class="mc-spring-board-form-body">
          <mc-site-teams-list #siteTeamsList [siteId]="site.Id" [canEdit]="(canManageSites$ | async)" (saved)="onSaved()"></mc-site-teams-list>
        </div>
      </div>

      <mc-popup #addSiteTeamsPopup (closed)="onSiteTeamsPopupClosed()">
        <div class="mc-spring-board">
          <div class="mc-spring-board-form-body">
            <mat-form-field mcColor="secondary" class="mc-form-field mc-form-field-compact">
              <mat-label>Add Site Teams</mat-label>
              <mc-autocomplete-input #siteTeamsAutoComplete [multiple]="true" [closePopupOnSelection]="true" [triggerPopupOnFocus]="false" placeholder="Type to find teams">
                <mc-teams-select-list mcAutocompleteList [licenseId]="site.LicenseId"></mc-teams-select-list>
                <ng-template mcAutocompleteItem let-teamId="item">
                  <mc-team-avatar compact [disabled]="true" [team]="teamId | mcTeamAsync | async" size="small" [truncate]="true"></mc-team-avatar>
                </ng-template>
              </mc-autocomplete-input>
            </mat-form-field>
          </div>
          <div class="mc-spring-board-form-footer">
            <div class="mc-form-buttons">
              <button type="button" mat-stroked-button color="warn" (click)="onCancelSiteTeamsClicked()">Cancel</button>
              <button type="button" mat-raised-button color="primary" (click)="onAddSiteTeamsClicked()">Add Teams to Site</button>
            </div>
          </div>
        </div>
      </mc-popup>
    </mat-tab>
  </mat-tab-group>

  <div class="mc-spring-board-form-footer">
    <mc-errors-expansion-panel *ngIf="savingState.generalError$ | async as generalError" compact [generalError]="generalError" [detailedErrors]="savingState.detailedErrors$ | async"></mc-errors-expansion-panel>
  </div>

  <!--Saving State-->
  <mc-loader *ngIf="savingState.loading$ | async" class="mc-loader-semi-transparent"></mc-loader>
</form>